import type { TemplateListResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export async function getTemplates(workspaceSlug: string): Promise<TemplateListResponse> {
  const response = await AuthAxios.get<TemplateListResponse>(
    `/api/v1.0/e/${workspaceSlug}/notification-templates`,
  )
  return response.data
}
